var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.767,
    height: 16.5,
    viewBox: "0 0 12.767 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91633",
    d: "M3.6 6.033A3.071 3.071 0 0 1 6.633 3a3.071 3.071 0 0 1 3.034 3.033 3.071 3.071 0 0 1-3.034 3.034A3.071 3.071 0 0 1 3.6 6.033zM6.633 12.8A6.023 6.023 0 0 0 1 16.267V18h11.267v-1.733A6.023 6.023 0 0 0 6.633 12.8z",
    transform: "translate(-.25 -2.25)",
    style: {
      fill: "none",
      stroke: "#6e6a65",
      strokeWidth: "1.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleOpened);
export default __webpack_public_path__ + "static/media/people-opened.svg";
export { ForwardRef as ReactComponent };